import { navigate } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import { CenteredLink } from '@ui/atoms/CenteredLink';
import { DashboardCardLayout } from '@ui/atoms/DashboardCardLayout';
import FlexColumn from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';

import { IPageProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme';

export interface IReactivateMembershipSuccessPageContent {
	heading: string;
	firstParagraph: string;
	secondParagraph?: string;
}

interface IReactivateMembershipSuccessProps extends IPageProps {
	pageContent: IReactivateMembershipSuccessPageContent;
}

const ReactivateMembershipSuccessCardLayout = styled(DashboardCardLayout)`
	max-width: 100%;
	overflow-x: hidden;
	padding: 0 ${theme.spacing.md};
	@media ${theme.responsive.breakpoints.laptop} {
		overflow-x: visible;
		padding: 0;
	}
`;

const TextArea = styled(FlexColumn)`
	padding: ${theme.spacing.md} 0;
`;

const ReactivateMembershipSuccess = ({ pageContent }: IReactivateMembershipSuccessProps) => {
	const { heading, firstParagraph, secondParagraph } = pageContent;

	return (
		<ReactivateMembershipSuccessCardLayout>
			<HeadingText>{heading}</HeadingText>

			<TextArea gap="sm">
				<BasicText>{firstParagraph}</BasicText>
				{!!secondParagraph && <BasicText>{secondParagraph}</BasicText>}
			</TextArea>

			<FlexColumn gap="sm">
				<Button
					label="Book a visit"
					onClick={() => navigate('../../get_care')}
					variant="secondary"
					labelSize="sm"
				/>
				<CenteredLink variant="underline" to="../../">
					Explore my FOLX account
				</CenteredLink>
			</FlexColumn>
		</ReactivateMembershipSuccessCardLayout>
	);
};

export default ReactivateMembershipSuccess;
